/* global process */
let base = window._env_.VUE_APP_FIN_CENTER_HOST
export const getPaymentManagerTable = params => {
  return axios.post(`${base}/payment-applications/list`, params)
}

export const getPaymentManagerDetail = params => {
  return axios.get(`${base}/payment-applications/${params.id}`, {params})
}
export const getPaymentDetailFinanceApi = params => {
  return axios.get(`${base}/payment-applications/${params.id}/finance`, {params})
}
export const exportPaymentManagerData = params => {
  return axios.get(`${base}/exportPaymentManagerData/${params.id}`, {params})
}
export const createPaymentManagerData = params => {
  return axios.post(`${base}/payment-applications`, params)
}
export const updatePaymentManagerData = params => {
  return axios.put(`${base}/payment-applications/${params.id}`, params)
}
export const deletePaymentManagerData = params => {
  return axios.post(`${base}/deletePaymentManagerData/${params.id}`, params)
}

export const exportTableData = params => {
  return axios.post(`${base}/payment-applications/list/export`, params)
}

export const exportDetailTableData = params => {
  return axios.post(`${base}/payment-applications/list/export/detail`, params)
}

export const exportWriteOffDetailTableData = params => {
  return axios.post(`${base}/payment-applications/list/export/write_off_detail`, params)
}

export const exportWriteOffStatusData = params => {
  return axios.post(`${base}/payment-applications/list/export/write_off_status`, params)
}

export const exportExportSearchAggregateData = params => {
  return axios.post(`${base}/payment-applications/summary`, params)
}

export const getuserAccountDetailByUserID = params => {
  return axios.get(`${base}/user-accounts/${params.id}/user`, {params})
}

// 放弃付款申请
export const abandonPaymentApplication = params => {
  return axios.put(`${base}/payment-applications/${params.id}/abandon`, params)
}

// 审核 is_rejected 0 通过，1 驳回请求 reason
export const reviewPaymentApplication = params => {
  return axios.put(`${base}/payment-applications/${params.id}/status`, params)
}

// 会计审批
export const accountantReviewPaymentApplication = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/accountant/status`, params)
}

// 财务审批
export const managerReviewPaymentApplication = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/manager/status`, params)
}

// 财务付款
export const paymentApplication = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/payment`, params)
}

// 财务拒绝付款
export const rejectedPayment = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/reject`, params)
}

// 财务冲销
export const writeOffApplication = params => {
  return axios.post(`${base}/payment-applications/${params.id}/write_off`, params)
}

// 财务修改实付金额
export const editPaidAmountAfterPaid = params => {
  return axios.put(`${base}/payment-applications/${params.id}/finance/paid_amount`, params)
}

// 退款
export const refundPayment = params => {
  return axios.post(`${base}/payment-applications/${params.id}/finance/refund`, params)
}

export const exportPaymentApplicationPDF = params => {
  return `${base}/payment-applications/${params.id}/pdf`
}

export const uploadRefundFiles = params => {
  return axios.post(`${base}/payment-applications/${params.id}/finance/refund`, params)
}

// 付款管理退款附件上传
export const finCenterUploadPaymentRefundFile = params => {
  return axios.post(`${base}/payment-refund/attached_files`, params)
}

// 付款管理上传附件
export const finCenterUploadPaymentApplyFile = params => {
  return axios.post(`${base}/payment-applications/attached_files`, params)
}

// 获取访问资源 url
export const getFinCenterFileUrl = params => {
  return axios.get(`${base}/oss_file_url`, {params})
}

// 获取下载url
export const getFinCenterFileUrlForDownload = params => {
  return `${base}/oss_file_download?name=file&type=${params.type}&url=${params.url}`
}

// 批量下载附件
export const exportPaymentApplicationsBatchPdfs = params => {
  return axios.post(`${base}/payment-applications/batch/pdfs`, params)
}

export const getFinCenterConfigs = params => {
  return axios.get(`${base}/payment/settings`, {params})
}

export const setFinCenterConfigs = params => {
  return axios.post(`${base}/payment/settings`, params)
}

// 获取审批人真实姓名
export const fetchApproverRealName = params => {
  return axios.post(`${base}/user-accounts/query_userinfo`, params)
}


// 7.0.0 财务新增接口
// 添加新的冲销申请
export const createPaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/create`, params)
}

// 编辑冲销申请
export const updatePaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/${params.id}/edit`, params)
}

// 审批人通过审批
export const approverPassPaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/${params.id}/approver_pass`, params)
}

// 财务会计通过
export const finAccountantPassPaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/${params.id}/finance/accountant_pass`, params)
}

// 财务经理通过
export const finManagerPassPaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/${params.id}/finance/manager_pass`, params)
}

// 审批驳回
export const rejectPaymentWriteOffData = params => {
  return axios.post(`${base}/payment-applications/write_off/${params.id}/reject`, params)
}




// WEBPACK FOOTER //
// ./src/views/payment-manager/payment-manager.api.js